export const READ_ANYTHINGS = 'READ_ANYTHINGS';
export const CREATE_ANYTHING = 'CREATE_ANYTHING';
export const UPDATE_ANYTHING = 'UPDATE_ANYTHING';
export const DELETE_ANYTHING = 'DELETE_ANYTHING';

// eslint-disable-next-line no-shadow
export const readAnythingsAction = (things, queryId = 'default') => ({
  type: READ_ANYTHINGS,
  payload: {
    things,
    queryId,
  },
});

export const createAnythingAction = (thing, queryId = 'default') => ({
  type: CREATE_ANYTHING,
  payload: {
    thing,
    queryId,
  },
});

export const updateAnythingAction = (thing, queryId = 'default') => ({
  type: UPDATE_ANYTHING,
  payload: {
    thing,
    queryId,
  },
});

export const deleteAnythingAction = (_id, queryId = 'default') => ({
  type: DELETE_ANYTHING,
  payload: {
    _id,
    queryId,
  },
});

const initialAnythings = { default: {} };

export function things(state = initialAnythings, action) {
  switch (action.type) {
    case READ_ANYTHINGS: {
      const newState = {
        ...state,
        [action.payload.queryId]: { ...state[action.payload.queryId] },
      };
      action.payload.things.forEach((p) => {
        newState[action.payload.queryId][p._id] = p;
      });
      return newState;
    }
    case CREATE_ANYTHING:
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.thing._id]: action.payload.thing,
        },
      };
    case UPDATE_ANYTHING: {
      const current =
        (state[action.payload.queryId] &&
          state[action.payload.queryId][action.payload.thing._id]) ||
        undefined;
      return {
        ...state,
        [action.payload.queryId]: {
          ...state[action.payload.queryId],
          [action.payload.thing._id]: {
            ...current,
            ...action.payload.thing,
          },
        },
      };
    }
    case DELETE_ANYTHING: {
      const { thingId } = action.payload;
      return Object.entries(state).reduce((prev, [key, val]) => {
        prev[key] = {
          ...val,
          [thingId]: undefined,
        };
        return prev;
      }, {});
    }
    default:
      return state;
  }
}
